import getGraphQlClient from '~graphql/getGraphQlClient';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import {
  FETCH_ALLEGATI,
  FETCH_ALLEGATI_WITH_AI_FIELDS,
} from '../../queries/allegati';

export default async function fetchAllegati(
  where = {},
  order = [],
  first = 100
) {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    fetchPolicy: 'network-only',
    variables: {
      where,
      order,
      first,
    },
    query: FETCH_ALLEGATI,
  });

  const allegati = await unmarshalGraphqlResponse(result.data, 'allegatis')
    .edges;

  return allegati;
}

export async function fetchAllegatiWithAiFields(
  where = {},
  order = [],
  first = 100
) {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    fetchPolicy: 'network-only',
    variables: {
      where,
      order,
      first,
    },
    query: FETCH_ALLEGATI_WITH_AI_FIELDS,
  });

  const allegati = await unmarshalGraphqlResponse(result.data, 'allegatis')
    .edges;

  return allegati;
}

export async function fetchAllegatiByIds(ids = [], batchSize = 100) {
  const uniqueIds = Array.from(new Set(ids.filter(Boolean)));

  if (!uniqueIds.length) {
    return [];
  }

  const batches = [];

  for (let index = 0; index < uniqueIds.length; index += batchSize) {
    batches.push(uniqueIds.slice(index, index + batchSize));
  }

  const results = await Promise.all(
    batches.map((batch) =>
      fetchAllegatiWithAiFields(
        {
          objectId: {
            in: batch,
          },
        },
        [],
        batch.length
      )
    )
  );

  return results.flat();
}
